import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the CoinSummaryDetailCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'coin-summary-detail-card',
  templateUrl: 'coin-summary-detail-card.html'
})
export class CoinSummaryDetailCardComponent {
  @Input('details') details: string;
  @Input('title') title: string;
  selected: boolean = false;
  parsed: string;
  baseURL = 'https://www.cryptocompare.com';
  paragraphs = [];
  constructor(private iab: InAppBrowser) {

  }

  ngOnInit(){
    this.parseHTML();
  }

  parseHTML(){
    let origin = document.location.origin;
    let parser = new DOMParser();
    let html = parser.parseFromString(this.details, 'text/html');
    let paragraphs = html.getElementsByTagName('p');


    // let links: Item[] = [];
    for(let i = 0; i < paragraphs.length; i++){
      let items: Item[] = [];
      let aTags: Item[] = [];
      let p = paragraphs.item(i);

      let text = p.innerText;
      let links = p.getElementsByTagName('a');

      //Get link items
      for(let j = 0; j < links.length; j++){
        let link = links.item(j).href.replace(origin, this.baseURL);
        let text = links.item(j).innerText;
        aTags.push({url: link, text: text});
      }

      for(let link of aTags){
        let splitText = text.split(link.text);
        items.push({
          text: splitText[0],
          url: null
        })

        items.push({
          text: link.text,
          url: link.url
        });

        text = splitText[1];
      }

      items.push({
        text: text,
        url: null
      })

      this.paragraphs.push(items);
    }

  }

  openLink(link: string, event: Event){
    event.stopPropagation();
    this.iab.create(link);
  }

  parseLink(link: string): string{
    let url = document.location.origin;
    return link;
  }

}

interface Item {
  text: string,
  url: string
}



// WEBPACK FOOTER //
// ./src/components/coin-summary-detail-card/coin-summary-detail-card.ts